module.exports = __webpack_public_path__ + "img/29.57e6baa9.png";